import React from 'react'
import {createRoot} from 'react-dom/client'
import {SeasonProgress, SeasonProgressProps} from './SeasonProgress'

export interface UILeaderboardSeasonProgressView {
    render: (props: SeasonProgressProps) => void
}

export const createUILeaderboardsSeasonProgressView = (element: HTMLElement): UILeaderboardSeasonProgressView => {
    const rootView = createRoot(element)
    return {
        render: (props: SeasonProgressProps) => {
            rootView.render(<SeasonProgress {...props} />)
        },
    }
}
